import PropTypes from 'prop-types';
import ActiveJourneyPill from 'components/elements/active-journey-pill';
import { fetchCreatorInfo } from 'apps/tasks/utils/fetch-helpers';
import { useEffect, useState } from 'react';

const CadenceIndicator = ({ journeyResponse }) => {
  const creatorUserId = journeyResponse?.journey?.creator_user_id;
  const [activeCadence, setActiveCadence] = useState(null);

  useEffect(() => {
    const fetchInfo = async () => {
      if (creatorUserId) {
        const info = await fetchCreatorInfo(creatorUserId);

        const activeCadence = {
          journey_name: journeyResponse?.journey?.name,
          journey_id: journeyResponse?.journey?.id,
          step_number: journeyResponse?.journey_tasks?.[0]?.journey_task?.step_number,
          day_number: journeyResponse?.journey_tasks?.[0]?.journey_task?.day_number,
          owner: info[creatorUserId],
        };

        setActiveCadence(activeCadence);
      }
    };
    fetchInfo();
  }, [creatorUserId, journeyResponse?.journey?.name, journeyResponse?.journey?.id, journeyResponse?.journey_tasks]);

  return (
    <div className="outreach-card-tab-group--item outreach-custom-active-pill">
      {activeCadence && <ActiveJourneyPill activeCadence={activeCadence} />}
    </div>
  );
};

CadenceIndicator.propTypes = {
  journeyResponse: PropTypes.object,
};

export default CadenceIndicator;
